import { fadeUp } from "animations/variants";
import { motion, AnimatePresence } from "framer-motion";

import React from "react";

const WorkshopHero = () => {
  return (
    <section className="relative w-full min-h-screen bg-gradient-to-br from-blue-700 via-blue-500 to-indigo-800 flex items-center justify-center px-4 py-10 overflow-hidden">
      <div className="flex flex-col items-center  justify-center gap-y-6">
        <h1 className="text-xl lg:text-2xl font-bold tracking-widest uppercase text-center">
          Accelerating Business Growth Coaching Workshop
        </h1>
        <p className="text-lg lg:text-2xl text-center">
          HỘI THẢO HUẤN LUYỆN TĂNG TỐC PHÁT TRIỂN KINH DOANH
        </p>
        <motion.div
          variants={fadeUp}
          className="mt-6 flex items-center justify-center gap-4"
        >
          <div className="w-20 border-t border-dashed border-gray-300"></div>
          <span className="w-2 h-2 bg-white rounded-full"></span>
          <span className="w-2 h-2 bg-white rounded-full"></span>
          <span className="w-2 h-2 bg-white rounded-full"></span>
          <div className="w-20 border-t border-dashed border-gray-300"></div>
        </motion.div>
        <img src="/maria/maria.png" className="rounded" />
        <div className="max-w-6xl mx-auto px-6 py-20">
          <motion.div variants={fadeUp} className="text-center mb-16">
            <h3 className="text-2xl font-semibold text-yellow-400 mb-6">
              For Business Owners Ready To Level Up
            </h3>

            <p className="text-lg md:text-xl max-w-3xl mx-auto opacity-95">
              Designed for entrepreneurs who want clarity, confidence, and a
              practical roadmap to sustainable business growth.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WorkshopHero;
